import {
  getConsentSync,
  subscribeToConsent
} from '@client/core/utils/consent.js';
import { ConsentStatus, debugLog } from '@schibsted-nmp/advertising-shared';

type ChangeCallback = (next: ConsentStatus) => void;

let isConsentListenerStarted = false;
let currentStatus: ConsentStatus | null = null;
const listeners = new Set<ChangeCallback>();

function toStatus(hasConsented: boolean): ConsentStatus {
  return hasConsented ? ConsentStatus.Accepted : ConsentStatus.Rejected;
}

function notifyConsentChange(newConsentStatus: ConsentStatus) {
  if (currentStatus === newConsentStatus) return;
  currentStatus = newConsentStatus;
  for (const consentCallback of Array.from(listeners)) {
    try {
      consentCallback(newConsentStatus);
    } catch (err) {
      debugLog('consentListener onChange threw', err);
    }
  }
}

export function onConsentChange(callback: ChangeCallback): () => void {
  listeners.add(callback);
  if (currentStatus !== null) callback(currentStatus);
  return () => listeners.delete(callback);
}

export function startConsentListener(onChange: ChangeCallback): void {
  if (isConsentListenerStarted) {
    onConsentChange(onChange);
    return;
  }
  isConsentListenerStarted = true;

  try {
    const syncConsentStatus = getConsentSync();
    if (syncConsentStatus !== null)
      notifyConsentChange(toStatus(syncConsentStatus));
  } catch (err) {
    debugLog('consentListener seed getConsentSync failed', err);
  }

  try {
    subscribeToConsent((updatedConsentValue) => {
      notifyConsentChange(toStatus(updatedConsentValue));
    });
  } catch (err) {
    debugLog('consentListener subscribeToConsent error', err);
  }

  onConsentChange(onChange);
}
